import React, { Component } from 'react'
import { TABLA_DETALLE_POR_CONDICION_LINEA_3 } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDetallePorCondicionLinea3View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_POR_CONDICION_LINEA_3} />
    )
  }
}
